var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!!_vm.item)?_c('ViewUserRoster',{on:{"success":_vm.alertSuccess}}):_vm._e(),_c('UserRosterTable',{ref:"table",attrs:{"title":"Users"},on:{"addRoster":_vm.showUserRosterModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }